import Phaser from 'phaser';
import { LOGICAL_WIDTH, LOGICAL_HEIGHT } from '../render/layout';
import { makeTwoPassText } from '../render/twoPassText';

interface OhNoData {
  parkName: string;
  levelNumber: number;
  onReplay: () => void;
}

export class OhNoScene extends Phaser.Scene {
  private initData: OhNoData | null = null;

  constructor() {
    super({ key: 'OhNo' });
  }

  init(data: OhNoData): void {
    this.initData = data;
  }

  create(): void {
    const d = this.initData;
    if (!d) return;
    this.cameras.main.setBackgroundColor('#5fa84a');
    const cx = LOGICAL_WIDTH / 2;

    // Same ip6.png background as the Interstitial good-job screen.
    this.add.image(0, 0, 'ip6').setOrigin(0, 0).setDisplaySize(LOGICAL_WIDTH, LOGICAL_HEIGHT);

    makeTwoPassText(this, cx, 240, 'Oh no!', { fontSize: '128px' });
    makeTwoPassText(this, cx, 660, d.parkName, { fontSize: '104px' });
    makeTwoPassText(this, cx, 800, `Level ${d.levelNumber}`, { fontSize: '80px' });

    // Replay pill button — matches the Interstitial "Get your score" / "Go to
    // the next park!" styling: yellow fill, red stroke, fully rounded ends.
    const btnY = LOGICAL_HEIGHT - 280;
    const btnText = makeTwoPassText(this, cx, btnY, 'Replay Park', {
      fontSize: '52px',
      depth: 11,
    });
    const btnTextW = btnText.fill.width - 32;
    const btnW = btnTextW + 96;
    const btnH = 96;
    const btnR = btnH / 2;
    const btnBg = this.add.graphics().setDepth(10);
    btnBg.fillStyle(0xffeb00, 1);
    btnBg.fillRoundedRect(cx - btnW / 2, btnY - btnH / 2, btnW, btnH, btnR);
    btnBg.lineStyle(6, 0xcc0000, 1);
    btnBg.strokeRoundedRect(cx - btnW / 2, btnY - btnH / 2, btnW, btnH, btnR);
    this.add
      .rectangle(cx, btnY, btnW, btnH, 0x000000, 0)
      .setOrigin(0.5)
      .setDepth(12)
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => {
        d.onReplay();
        this.scene.stop();
      });
  }
}
